'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('../../slicedToArray-e6d9072a.js');
var React = require('react');
var index = require('../../index-6ed9f31c.js');
var components_LockScroll_LockScroll = require('../LockScroll/LockScroll.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var components_Button_Button = require('../Button/Button.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('styled-components');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/isType/isType.js');
require('../../theme-340a6118.js');
require('../../extends-f8003900.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../objectWithoutProperties-aa43106a.js');
require('../../Icon-52b6461b.js');
require('../../defineProperty-3cad0327.js');
require('../Typography/Typography.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../NuDSProvider/NuDSProvider.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../xstyled-prop-types.es-7d7acd76.js');
require('../../withIntlAriaAttrs-82b869b1.js');
require('../../utils/ref/refType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject$3, _templateObject2$2;
var ORIGIN_DIRECTION = {
  top: 'translate3d(0, -100%, 0)',
  right: 'translate3d(100%, 0, 0)',
  bottom: 'translate3d(0, 100%, 0)'
};
var DrawerContainer = xstyledStyledComponents_es.styled.div(_templateObject$3 || (_templateObject$3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  background: ", ";\n  position: fixed;\n  right: 0;\n  top: 0;\n  height: 100%;\n  max-width: 100%;\n  width: ", ";\n  will-change: transform;\n  z-index: 4000;\n  transition: 300ms;\n  overflow-x: hidden;\n  transform: ", ";\n\n  ", "\n"])), styles_themeUtils.nuDSColor('white'), function (props) {
  return props.width;
}, function (props) {
  return props.open ? 'translate3d(0, 0, 0)' : ORIGIN_DIRECTION[props.direction];
}, styles_breakpoints.tablet768(_templateObject2$2 || (_templateObject2$2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    transform: ", ";\n  "])), function (props) {
  return props.open ? 'translate3d(0, 0, 0)' : ORIGIN_DIRECTION[props.desktopDirection];
}));
DrawerContainer.propTypes = {
  desktopDirection: index.PropTypes.string.isRequired,
  direction: index.PropTypes.string.isRequired,
  open: index.PropTypes.bool.isRequired,
  width: index.PropTypes.string.isRequired
};
DrawerContainer.displayName = 'DrawerContainer';

var _templateObject$2, _templateObject2$1, _templateObject3;

var handleVisibility = function handleVisibility(_ref) {
  var open = _ref.open;

  if (open) {
    return xstyledStyledComponents_es.css(_templateObject$2 || (_templateObject$2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      opacity: 1;\n      pointer-events: auto;\n    "])));
  }

  return xstyledStyledComponents_es.css(_templateObject2$1 || (_templateObject2$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    opacity: 0;\n    pointer-events: none;\n  "])));
};

var BodyOverlay = xstyledStyledComponents_es.styled.div(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3000;\n  overflow: hidden;\n\n  ", ";\n\n  transform: translate3d(0, 0, 0);\n  background: ", ";\n  transition: opacity 50ms ease-out 0s, transform 50ms ease-in-out 0s;\n"])), handleVisibility, styles_themeUtils.nuDSColor('black', 'defaultT70'));
BodyOverlay.propTypes = {
  open: index.PropTypes.bool.isRequired
};
BodyOverlay.displayName = 'BodyOverlay';

var DrawerContext = /*#__PURE__*/React.createContext({
  hideCloseButton: false,
  toggleCloseButton: function toggleCloseButton() {}
});

var _templateObject$1, _templateObject2;

function setButtonVisibility(_ref) {
  var hideCloseButton = _ref.hideCloseButton;

  if (hideCloseButton) {
    return xstyledStyledComponents_es.css(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    & > button {\n      display: none;\n    }\n  "])));
  }

  return undefined;
}

var DrawerHeaderWrapper = xstyledStyledComponents_es.styled.header(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  background: ", ";\n  padding: 1rem;\n  flex-shrink: 0;\n\n  & > button {\n    height: 3rem;\n  }\n\n ", "\n"])), styles_themeUtils.nuDSColor('white'), setButtonVisibility);
DrawerHeaderWrapper.propTypes = {
  hideCloseButton: index.PropTypes.bool.isRequired
};
DrawerHeaderWrapper.displayName = 'DrawerHeaderWrapper';

var DrawerHeader = function DrawerHeader(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var drawerCtx = React.useContext(DrawerContext);
  return /*#__PURE__*/React__default['default'].createElement(DrawerHeaderWrapper, {
    className: className,
    hideCloseButton: drawerCtx.hideCloseButton
  }, children);
};

DrawerHeader.defaultProps = {
  className: undefined
};
DrawerHeader.propTypes = {
  children: index.PropTypes.node.isRequired,
  className: index.PropTypes.string
};

var DrawerCloseButton = function DrawerCloseButton(_ref) {
  var onClick = _ref.onClick,
      title = _ref.title;
  var createButtonRef = React.useRef(null);
  React.useEffect(function () {
    if (createButtonRef && createButtonRef.current) {
      createButtonRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React__default['default'].createElement(components_Button_Button['default'], {
    ref: createButtonRef,
    variant: "basic",
    styleVariant: "primary",
    onClick: onClick,
    iconProps: {
      name: 'x',
      title: title
    }
  });
};

DrawerCloseButton.defaultProps = {
  title: 'Close'
};
DrawerCloseButton.propTypes = {
  onClick: index.PropTypes.func.isRequired,
  title: index.PropTypes.string
};

var _templateObject;
var DrawerContentWrapper = xstyledStyledComponents_es.styled.div(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 100%;\n"])));
DrawerContentWrapper.displayName = 'DrawerContentWrapper';

var DrawerContent = function DrawerContent(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default['default'].createElement(DrawerContentWrapper, {
    className: className
  }, children);
};

DrawerContent.defaultProps = {
  className: undefined
};
DrawerContent.propTypes = {
  children: index.PropTypes.node.isRequired,
  className: index.PropTypes.string
};

var ESCAPE_KEY_CODE = 27;

var createEscapeHandler = function createEscapeHandler(targetFn) {
  return function (event) {
    if (event.keyCode === ESCAPE_KEY_CODE) {
      targetFn();
    }
  };
};

var Drawer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var open = props.open,
      onClose = props.onClose,
      children = props.children,
      direction = props.direction,
      desktopDirection = props.desktopDirection,
      id = props.id,
      lockScroll = props.lockScroll,
      width = props.width,
      className = props.className;
  var drawerContext = React.useContext(DrawerContext);

  var _useState = React.useState(drawerContext.hideCloseButton),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      hideCloseButton = _useState2[0],
      setButtonHidden = _useState2[1];

  var handleCloseButtonToggle = function handleCloseButtonToggle() {
    setButtonHidden(!hideCloseButton);
  };

  React.useEffect(function () {
    var handleEscape = createEscapeHandler(onClose);

    if (open) {
      window.addEventListener('keydown', handleEscape, false);
    }

    return function () {
      window.removeEventListener('keydown', handleEscape, false);
    };
  }, [open, onClose]);
  var handleBodyOverlayClick = React.useCallback(function (event) {
    var isTheBodyOverlayClicked = event.target.getAttribute('role') === 'dialog';

    if (isTheBodyOverlayClicked) {
      onClose();
    }
  }, [onClose]);
  return /*#__PURE__*/React__default['default'].createElement(DrawerContext.Provider, {
    value: {
      hideCloseButton: hideCloseButton,
      toggleCloseButton: handleCloseButtonToggle
    }
  }, /*#__PURE__*/React__default['default'].createElement(BodyOverlay, {
    ref: ref,
    className: className,
    role: "dialog",
    onClick: handleBodyOverlayClick,
    open: open
  }, /*#__PURE__*/React__default['default'].createElement(DrawerContainer, {
    open: open,
    direction: direction,
    desktopDirection: desktopDirection,
    id: id,
    width: width
  }, open && children({
    DrawerHeader: DrawerHeader,
    DrawerCloseButton: DrawerCloseButton,
    DrawerContent: DrawerContent
  }))), /*#__PURE__*/React__default['default'].createElement(components_LockScroll_LockScroll['default'], {
    lockScroll: lockScroll,
    open: open
  }));
});
Drawer.defaultProps = {
  className: undefined,
  direction: 'right',
  desktopDirection: 'right',
  lockScroll: true,
  width: '30rem'
};
Drawer.propTypes = {
  /** The components that will be rendered inside the Drawer */
  children: index.PropTypes.func.isRequired,

  /** The class that will be applied to the HTML element */
  className: index.PropTypes.string,

  /** The Direction of the opening animation on the desktop breakpoint */
  desktopDirection: index.PropTypes.oneOf(['top', 'right', 'bottom']),

  /** The Direction of the default opening animation */
  direction: index.PropTypes.oneOf(['top', 'right', 'bottom']),

  /** The id property that will be applied to the HTML element */
  id: index.PropTypes.string.isRequired,

  /** A property to determine if the scroll of the page will be locked when Drawer is open */
  lockScroll: index.PropTypes.bool,

  /** A function responsible to close the Drawer */
  onClose: index.PropTypes.func.isRequired,

  /** A property to determine if the drawer is open */
  open: index.PropTypes.bool.isRequired,

  /** A property to determine the width size of the container */
  width: index.PropTypes.string
};

exports.ESCAPE_KEY_CODE = ESCAPE_KEY_CODE;
exports.default = Drawer;
//# sourceMappingURL=Drawer.js.map
